<div class="container-fluid bg-DocumentosCerti w-100 d-flex justify-content-center align-items-center">
  <div class="w-75">
    <span class="text-imagen">Sistema de Información y Gestión Educativa</span>
    <br>
    <span class="text-imagen">Validación de documentos académicos electrónicos</span>
  </div>
</div>


<div class="container div-form ">

  <div class="  d-flex flex-xl-row flex-column  justify-content-around align-items-center">

    <div class="">
      <input type="text" [value]="folio" class="" id="inputPassword2" placeholder="Password">
    </div>
    <div class="">
      <button type="submit" class="btn btn-buscar mb-3">Buscar</button>
    </div>
    <div class="">
      <button type="submit" class="btn btn-restablecer mb-3">Restablecer</button>
    </div>
  </div>
  <div class="w-100 d-flex align-items-center justify-content-center">
    <a class="badge a-folio">Ubica el folio en tu certificado</a>
  </div>

</div>

<div class="container pt-5 pb-5">
  <nav
    style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);"
    aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"></li>
      <li class="breadcrumb-item">Inicio</li>
      <li class="breadcrumb-item active" aria-current="page">Consultas</li>
      <li class="breadcrumb-item active" aria-current="page">Documentos académicos electrónicos</li>
    </ol>
  </nav>
</div>

<div class="container">
  <h3>Detalle del documento <i class="fa fa-file-text" style="color: gray;"></i></h3>
</div>
<div class="d-flex justify-content-center w-100 container">
  <div class="">
    <hr class="line-hr">
  </div>
  <div style="width: 80%;">
    <hr class="line2-hr">
  </div>
</div>
<ng-container *ngIf="folio; else elseTemplate">


  <ngx-extended-pdf-viewer 

  [src]="pdfSource" [showToolbar]="false" 
  [height]="dimensionW <= 414 ? '60vh':'90vh'"
  [showBorders]="false"
  [backgroundColor]="'#fff'"
    [zoom]="dimensionW < 600 ? '51%':'90%'" [useBrowserLocale]="true">
  </ngx-extended-pdf-viewer>


</ng-container>

<div class="d-flex justify-content-center w-100 container">
  <div class="">
    <hr class="line-hr">
  </div>
  <div style="width: 80%;">
    <hr class="line2-hr">
  </div>
</div>

<div class="container pt-5 pb-5">
  <p class="lh-sm ">La información de los certificados que se muestran en este portal, son el resultado de la
    integración de información que envían las autoridades educativas de los estados y la Ciudad de México. "En caso de
    que la información presentada no coincida con tus resultados obtenidos en el ciclo escolar o no esté disponible, por
    favor ponte en contacto con la autoridad de tu centro escolar."</p>
  <p class="lh-sm ">La información presentada es de carácter informativa y para verificar la validez del documento
    impreso. Es una representación de la información contenida en el certificado (documento impreso).</p>
  <p class="lh-sm ">El documento oficial es el que la institución Educativa entrega a los padres o tutores de los
    educandos en sus centros escolares.</p>
</div>
<ng-template #elseTemplate>
  <div class="w-100" style="height: 500px;"></div>
</ng-template>

<app-footer></app-footer>